// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1UIog","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3fCxj"};